import { combineReducers } from "redux";
import asyncStateReducer from "./asyncStateReducer";
import commonStateReducer from "./commonStateReducer";
import presentationStateReducer from "./presentationStateReducer";
import staticStateReducer from "./staticStateReducer";
import offCuffListStateReducer from "./offCuffListStateReducer";
const rootReducer = combineReducers({
  asyncStateReducer,
  commonStateReducer,
  presentationStateReducer,
  staticStateReducer,
  offCuffListStateReducer,
});

export default rootReducer;
